import React, { useEffect, useRef } from 'react';
import { useMicrosoftGraphUserInfo } from '../queries/useMicrosoftGraphUserInfo';

export function PendoProvider({ children }: { children: React.ReactNode }) {
    const { data } = useMicrosoftGraphUserInfo();
    const hasIdentified = useRef(false);

    useEffect(() => {
        if (!data?.mail || hasIdentified.current) {
            return;
        }

        hasIdentified.current = true;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'pendoIdentify',
            pendoVisitorId: data.mail.toLowerCase(),
            pendoVisitorName: data.displayName,
            pendoAccountId: `PADI - ${process.env.REACT_APP_ENVIRONMENT}`,
            pendoAppName: 'PADI',
        });
    }, [data]);

    return <>{children}</>;
}
